<div class="grid workflowFoldsHeader">
  <div class="col-6">
    <h3>{{'FOLD.WORKFLOW.LIST_COMPONENT.DATATABLE_TITLE' | translate}}</h3>
  </div>
  <div class="col-6 align-right">
    <p>{{'FOLD.WORKFLOW.LIST_COMPONENT.NUMBER_OF_SELECTED_ELEMENTS_LABEL' | translate}}:
      {{selectedFoldsIndexArray.length}}</p>
  </div>
</div>
<p-table #pdt_fold_workflow_list (onRowSelect)="handleSelectionOfRow($event)" [alwaysShowPaginator]="true"
         [columns]="columns" [paginatorPosition]="'top'" [paginator]="true" [rows]="DataTableFiller.NUMBER_OF_ROWS_FOR_WORKFLOW_FOLDS_LIST"
         [metaKeySelection]="false" [selection]="tempFoldSelection"
         [value]="listOfFolds" selectionMode="single" [rowHover]="true">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="width: 35px">
        <p-checkbox *ngIf="!tableIsFullOfEmpty()"  [binary]="true" [(ngModel)]="everyFoldIsSelected" (onChange)="handleAddOrRemoveEveryFolds($event)"></p-checkbox>
      </th>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{ 'width': col.width }">
        {{ col.header }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-group let-columns="columns" let-index="rowIndex">
    <tr [pSelectableRow]="group" [pSelectableRowDisabled]="group.notSelectable">
      <td>
        <p-checkbox *ngIf="listOfFolds[index] && !listOfFolds[index].notSelectable" [binary]="true" [ngModel]="rowIsSelected(index)" (onChange)="handleAddOrRemove($event, index)"></p-checkbox>
      </td>
      <td *ngFor="let column of columns">
        {{ group[ column.field ] }}
      </td>
    </tr>
  </ng-template>
</p-table>
